// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 562) return "static/chunks/562-0738b3cd4500d173.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 524 ? "0ea2cffb" : chunkId) + "." + {"322":"12459a841d033d2c","451":"0e1b3cbd8f78500e","524":"762c9c8e20030d81","552":"d7bee56845ac8fb4","661":"ded0c08607bd765d"}[chunkId] + ".js";
};